<template>
  <div>
    <template v-if="editSoaIndex === index && disableBreakdownAndIncoming">
      <input class="bb-table-body__input bb-input
                bb-input_border
                bb-input_border_transparent"
             :class="{'bb-input_error': error}"
             :disabled="disableInput"
             @focus="focusInput"
             @keyup.esc="hideEditSoa"
             @keyup.enter="createSoa"
             @input="changeInput('incoming', incomingModel)"
             v-model="incomingModel"
      >
    </template>
    <template v-else>
      <span>{{convertNumber(soa.incoming || 0)}}</span>
    </template>
  </div>
</template>

<script>
import convertNumber from '@/mixin/convertNumber'
import _ from 'lodash'
export default {
  name: 'IncomingColumn',
  mixins: [convertNumber],
  props: ['error', 'soa', 'editSoaIndex', 'disableInput', 'index', 'model'],
  computed: {
    disableBreakdownAndIncoming () {
      const services = _.get(this.soa, 'invoiceService', [])
      return !this.soa.isAutoSoa && !this.soa.isCreditNote && !services.length
    }
  },
  data () {
    return {
      incomingModel: this.model
    }
  },
  methods: {
    focusInput () {
      this.$emit('focusInput')
    },
    changeInput (type, value) {
      this.$emit('changeInput', type, value)
    },
    createSoa () {
      this.$emit('createSoa')
    },
    hideEditSoa () {
      this.$emit('hideEditSoa')
    }
  },
  watch: {
    model () {
      this.incomingModel = this.model
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../../sass/variables";
  @import "../../../../../../../../sass/mixins";
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/IncomingColumn.vue